import i18next from 'i18next';

import { getLanguageData } from '../all-langs';
import { fallbackLang } from '../locales-config';

// ----------------------------------------------------------------------

export const numberFormatLocale = () =>
  getLanguageData(i18next.language, fallbackLang).numberFormat;
